import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

(() => {
  if (window.__miyamiProductCardBound) return;
  window.__miyamiProductCardBound = true;

  const getCartItemsSectionIds = () => {
    const sections = [];
    document.querySelectorAll('cart-items-component').forEach((el) => {
      const sid = el.getAttribute('data-section-id');
      if (sid && !sections.includes(sid)) sections.push(sid);
    });
    return sections.length ? sections.join(',') : '';
  };

  const toMerchandiseId = (variantId) => {
    const id = String(variantId || '');
    if (!id) return '';
    if (id.startsWith('gid://')) return id;
    return `gid://shopify/ProductVariant/${id}`;
  };

  const animateAdded = (button) => {
    if (!button) return;

    window.clearTimeout(button._miyamiAddedTimer);

    if (button.dataset.addToCartAnimation === 'true') {
      const image = button.dataset.productVariantMedia;
      const cartIcon = document.querySelector('.header-actions__cart-icon');
      if (image && cartIcon && customElements.get('fly-to-cart')) {
        const flyToCartElement = document.createElement('fly-to-cart');
        flyToCartElement.classList.add('fly-to-cart--quick');
        flyToCartElement.style.setProperty('background-image', `url(${image})`);
        flyToCartElement.style.setProperty('--start-opacity', '0');
        flyToCartElement.source = button;
        flyToCartElement.destination = cartIcon;
        document.body.appendChild(flyToCartElement);
      }
    }

    button.setAttribute('data-added', 'true');
    button._miyamiAddedTimer = window.setTimeout(() => {
      button.removeAttribute('data-added');
    }, 1200);
  };

  const addToCart = async (variantId, { openDrawer = true, card = null } = {}) => {
    const deferredEventPromise = CartLinesUpdateEvent.createPromise();

    document.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [
          {
            merchandiseId: toMerchandiseId(variantId),
            quantity: 1,
          },
        ],
        promise: deferredEventPromise.promise,
      })
    );

    try {
      const sections = getCartItemsSectionIds();
      const bodyData = {
        id: Number(variantId),
        quantity: 1,
      };
      if (sections) bodyData.sections = sections;

      const cartAddUrl = window.Theme?.routes?.cart_add_url || '/cart/add.js';
      const response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        credentials: 'same-origin',
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        let errorMsg = `Add to cart failed (${response.status})`;
        try {
          const errJson = await response.json();
          if (errJson.description) errorMsg = errJson.description;
          else if (errJson.message) errorMsg = errJson.message;
        } catch (_) {}
        throw new Error(errorMsg);
      }

      const addResponse = await response.json();

      const cartUrl = window.Theme?.routes?.cart_url ? `${window.Theme.routes.cart_url}.js` : '/cart.js';
      const cartRes = await fetch(cartUrl, {
        credentials: 'same-origin',
      });
      const cartJson = cartRes.ok ? await cartRes.json() : { items: [addResponse], item_count: 1 };

      deferredEventPromise.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cartJson),
        detail: {
          items: cartJson.items,
          source: 'shop-by-product-card',
          itemCount: cartJson.item_count ?? 1,
          variantId,
          sections: addResponse?.sections || {},
          didError: false,
        },
      });

      if (openDrawer) {
        const drawer = document.querySelector('theme-drawer#cart-drawer');
        if (drawer && typeof drawer.open === 'function' && !drawer.isOpen) {
          drawer.open();
        }
      }

      return addResponse;
    } catch (error) {
      deferredEventPromise.reject(error);
      throw error;
    }
  };

  window.MiyamiProductCard = {
    animateAdded,
    addToCart,
    toMerchandiseId,
  };

  document.addEventListener('click', async (event) => {
    const sizeBtn = event.target.closest('[data-shop-by-product-size]');
    if (sizeBtn) {
      const card = sizeBtn.closest('[data-shop-by-product-card]');
      if (!card) return;
      card.querySelectorAll('[data-shop-by-product-size]').forEach((btn) => {
        btn.classList.toggle('is-selected', btn === sizeBtn);
      });
      const variantId = sizeBtn.getAttribute('data-variant-id');
      if (variantId) card.setAttribute('data-variant-id', variantId);
      return;
    }

    const cartBtn = event.target.closest('[data-shop-by-product-cart]');
    if (!cartBtn) return;

    const card = cartBtn.closest('[data-shop-by-product-card]');
    if (!card) return;

    const variantId = card.getAttribute('data-variant-id');
    if (!variantId) return;

    cartBtn.disabled = true;
    animateAdded(cartBtn);
    try {
      await addToCart(variantId, { openDrawer: true, card });
    } catch (error) {
      console.error(error);
      cartBtn.removeAttribute('data-added');
    } finally {
      cartBtn.disabled = false;
    }
  });
})();
